export default __webpack_public_path__ + "static/media/erp.1d47f732.svg";